import React, { PropsWithChildren } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

// material
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      // maxHeight: "calc(100vh - 70px)",
    },
  })
);

const AuthLayout = (props: PropsWithChildren<{ showInfo?: boolean }>) => {
  const { root } = useStyles();
  return (
    <>
      <div className={root}>{props.children}</div>
      {props.showInfo && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="70px"
          padding="10px"
        >
          <Typography align="center" variant="subtitle1">
            مرکز تماس قوه قضائیه: 57798000 -021
          </Typography>
          <Typography align="center" variant="subtitle1">
            مرکز پشتیبانی احراز هویت هوشمند ویدا: 66066142 -021
          </Typography>
          <Typography align="center" variant="caption">
            کلیه حقوق سامانه احراز هویت دیجیتال ویدا متعلق به شرکت کیاهوشان است.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default AuthLayout;
